import styled, { css } from 'styled-components';
import trash from '@panel/commons/assets/icons/icon_trash_48x48.svg';
import trashHover from '@panel/commons/assets/icons/icon_trash_48x48_hover.svg';
import trashIconHoverVa from '@panel/commons/assets/icons/icon_trash_48x48_hover_VA.svg';
import rotate from '@panel/commons/assets/icons/icon_rotate_48x48.svg';
import rotateHover from '@panel/commons/assets/icons/icon_rotate_48x48_hover.svg';
import rotateHoverVa from '@panel/commons/assets/icons/icon_rotate_48x48_hover_VA.svg';
import buttonStar from '@panel/commons/assets/icons/button-star.svg';
import buttonStarHover from '@panel/commons/assets/icons/button-star-hover.svg';
import buttonStarHoverVA from '@panel/commons/assets/icons/button-star-hover_VA.svg';
import starIcon from '@panel/commons/assets/icons/star.svg';
import { select, withQuery } from '@panel/commons/core/themev2';
import { isMobileDevice } from '@panel/commons/helpers/device';
import { getColor } from '@panel/commons/core/themev3';
import { site } from '@panel/commons/helpers';

const isMobile = isMobileDevice();
const siteId = site.id;
const iconTrashHover = siteId === 'VAMX' ? trashIconHoverVa : trashHover;
const iconRotateHover = siteId === 'VAMX' ? rotateHoverVa : rotateHover;
const iconStarHover = siteId === 'VAMX' ? buttonStarHoverVA : buttonStarHover;

const SubtitleHelper = styled.p`
  color: ${select('darkGray')};
  font-size: 1.4rem;
  margin-top: -20px;
`;

const SectionContainer = styled.div`
  display: flex;
`;

const HelperBox = styled.div`
  margin-top: 30px;
  width: 274px;
  height: 152px;
  border-radius: 8px;
  box-shadow: 1px 2px 16px 0 rgba(0, 0, 0, 0.05);
  border: solid 1px #e7eef0;
  display: flex;
  flex-flow: row nowrap;
  ${withQuery.xl.down()} {
    max-width: 192px;
    height: 190px;
  }
  ${withQuery.lg.down()} {
    display: none;
  }
  align-items: center;
  justify-content: center;

  svg {
    display: block;
    width: 40px;
    height: 45px;
    margin-right: 18px;
  }
  div {
    white-space: pre-wrap;
    width: 170px;
    height: 114px;
    font-family: Hind;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #68808c;
    ${withQuery.xl.down()} {
      height: 164px;
    }
  }
`;

const FilesContainer = styled.div`
  width: 100%;
  padding: 0;
  padding-top: 30px;
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  max-height: ${props => (props.isCollapsed ? '480px' : 'auto')};
  transition: max-height 1s;
  ${withQuery.xs.down()} {
    div:nth-child(2n) {
      margin-right: 0;
    }
  }
`;
const CollapseWrapper = styled.div`
  max-width: ${props => (props.hasItems ? '570px' : '558px')};
  width: 100%;
  margin-right: ${props => (props.hasItems ? '24px' : '36px')};
  ${withQuery.xl.down()} {
    margin-right: ${props => (props.hasItems ? '0px' : '14px')};
  }
  ${withQuery.lg.down()} {
    margin: 0 15px;
    margin-right: ${props => (props.hasItems ? '0px' : '24px')};
  }
  ${withQuery.sm.down()} {
    margin: 0;
  }
`;

const DropzoneContainer = styled.div`
  max-width: ${props => (props.hasItems ? '180px' : '558px')};
  width: 100%;
  border: dashed 1px ${getColor('primary')};
  height: ${props => (props.hasItems ? '216px' : '152px')};
  border-radius: 8px;
  padding: ${props => (props.hasItems ? '10px' : '0px')};
  background-color: ${select('white')};
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: width 1s linear 0.5s;
  &:hover {
    cursor: pointer;
    border-style: solid;
  }
  span {
    margin-top: 10px;
    font-family: 'Hind';
    font-weight: 500;
    letter-spacing: normal;
    word-wrap: break-word;
    white-space: pre-wrap;
    text-align: center;
  }
  margin-right: ${props => (props.hasItems ? '10px' : '0px')};
  margin-bottom: 15px;
  flex-grow: 1;
  transition: border 0.25s ease-in-out;
  ${withQuery.lg.down()} {
    max-width: ${props => (props.hasItems ? '165px' : '558px')};
  }
  ${withQuery.md.down()} {
    max-width: ${props => (props.hasItems ? '160px' : '558px')};
  }
  ${withQuery.xs.down()} {
    max-width: 150px;
    max-width: ${props => (props.hasItems ? '150px' : '558px')};
  }
  ${withQuery.xxs.down()} {
    max-width: 140px;
    max-width: ${props => (props.hasItems ? '140px' : '558px')};
  }
`;

const ImageBoxContainer = styled.div`
  width: 180px;
  height: 216px;
  border: 0.5px solid ${select('midDarkGray')};
  border-radius: 8px;
  background-color: ${select('white')};
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-bottom: 15px;
  position: relative;
  overflow: hidden;
  ${withQuery.lg.down()} {
    max-width: 165px;
  }
  ${withQuery.md.down()} {
    max-width: 160px;
  }
  ${withQuery.xs.down()} {
    max-width: 150px;
  }
  ${withQuery.xxs.down()} {
    max-width: 140px;
  }
`;

const MainMarker = styled.div`
  width: 100%;
  height: 30px;
  color: white;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 10px;
  background-color: ${siteId === 'VAMX' ? select('grayDarkLight') : select('violet')};
  border-radius: 8px 8px 0px 0px;
  text-align: center;
  position: absolute;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    height: 14px;
    width: 14px;
    margin-bottom: 4px;
    background-image: url(${starIcon});
    background-size: cover;
    margin-right: 8px;
  }
  ${withQuery.lg.down()} {
    max-width: 165px;
  }
  ${withQuery.md.down()} {
    max-width: 160px;
  }
  ${withQuery.xs.down()} {
    max-width: 150px;
  }
  ${withQuery.xxs.down()} {
    max-width: 140px;
  }
`;

const ImageBorderWrapper = styled.div`
  border-radius: 8px 8px 0px 0px;
  overflow: hidden;
  width: 180px;
  height: 176px;
  transition: height 1s ease;
  &:hover {
    cursor: move;
  }
  ${withQuery.lg.down()} {
    max-width: 165px;
    height: 100%;
    border-radius: 8px;
  }
  ${withQuery.md.down()} {
    max-width: 160px;
  }
  ${withQuery.xs.down()} {
    max-width: 150px;
  }
  ${withQuery.xxs.down()} {
    max-width: 140px;
  }
`;

const Image = styled.img`
  width: 178px;
  height: 176px;
  object-fit: cover;
  transition: height 1s ease;
  transform: ${props => (props.rotationAngle ? `rotate(${props.rotationAngle}deg)` : '')};
  ${withQuery.lg.down()} {
    max-width: 165px;
    height: 100%;
  }
  ${withQuery.md.down()} {
    max-width: 160px;
  }
  ${withQuery.xs.down()} {
    max-width: 150px;
  }
  ${withQuery.xxs.down()} {
    max-width: 140px;
  }
`;

const Editable = styled.input`
  font-size: 12px !important;
  height: 35px;
  width: 172px;
  text-overflow: ellipsis;
  border-radius: 0px 0px 8px 8px;
  margin: 0 5px;
  color: ${select('darkGray')};
  ::placeholder {
    color: ${select('darkGray')};
  }
  ${withQuery.lg.down()} {
    display: none;
  }
`;

const Controls = styled.div`
  position: absolute;
  width: 100%;
  text-align: right;
  z-index: 3;
  bottom: 34px;
  visibility: hidden;
  transition: visibility 0s ease-out;
  padding-right: 8px;
  ${ImageBoxContainer}:hover & {
    visibility: visible;
  }
  box-sizing: border-box;
  overflow: hidden;
  ${withQuery.lg.down()} {
    visibility: visible;
    bottom: 0px;
    padding-right: 4px;
    ${ImageBoxContainer}:hover & {
      visibility: visible;
    }
  }
  span:last-child {
    margin: 0;
  }
`;

const mobileEventConfig = hoverImg => {
  return isMobile
    ? css`
        &:active {
          background-image: url(${hoverImg});
        }
      `
    : css`
        &:hover {
          background-image: url(${hoverImg});
        }
      `;
};

const Rotator = styled.span`
  width: 48px;
  height: 48px;
  cursor: pointer;
  display: inline-block;
  background-image: url(${rotate});
  background-size: cover;
  margin-right: 4px;
  ${withQuery.xs.down()} {
    width: 44px;
    height: 44px;
  }
  ${mobileEventConfig(iconRotateHover)}
`;

const Deletor = styled(Rotator)`
  background-image: url(${trash});
  ${mobileEventConfig(iconTrashHover)}
`;

const MainSelector = styled(Rotator)`
  background-image: url(${buttonStar});
  ${mobileEventConfig(iconStarHover)}
`;

const LoadingView = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  .loader {
    position: relative;
    margin: 0 auto;
    width: $width;
    z-index: 4;
    &:before {
      content: '';
      display: block;
      padding-top: 100%;
    }
  }

  .circular {
    animation: rotate 3s linear infinite;
    height: 50%;
    transform-origin: center center;
    width: 50%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    stroke-linecap: round;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35px;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124px;
    }
  }

  @keyframes color {
    0% {
      stroke: ${getColor('primary')};
    }
  }
`;

const SnackContainer = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
  height: 50px;
  padding: 0;
`;

const CollapseCheck = styled.div`
  font-size: 16px;
  font-family: 'Hind';
  width: 150px;
  height: 24px;
  font-weight: 600;
  line-height: 1.3;
  color: ${getColor('primary')};
  display: ${props => (props.showCollapse ? 'flex' : 'none')};
  margin-top: 20px;
  > div {
    margin-right: 8px;
  }
  &:hover {
    cursor: pointer;
  }
`;

const CollapseContainer = styled.div`
  max-height: ${props => (props.isCollapsed ? `490px` : `${props.maxHeight}px`)};
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: content-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: max-height 1s ease;
  overflow: hidden;
  ${withQuery.xs.down()} {
    width: 314px;
  }
`;

const ImgOverlay = styled.div`
  z-index: 3;
  background: ${props => props.error && select('negative')};
  width: 100%;
  height: ${props => (props.error ? '100%' : '82%')};
  position: absolute;
  opacity: 0.7;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  white-space: normal;
  color: ${select('white')};
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  p:nth-of-type(2) {
    font-size: 14px;
  }
`;

const CardShowMore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  height: 216px;
  background: linear-gradient(145.22deg, ${select('white')} 0%, ${select('lightGray')} 100%);
  border-radius: 8px;
  border: 0.5px solid ${select('midDarkGray')};
  > div:nth-child(1) {
    margin-top: 52px;
    font-size: 32px;
    color: ${getColor('primary')};
    font-weight: bold;
  }
  ${withQuery.lg.down()} {
    max-width: 165px;
  }
  ${withQuery.md.down()} {
    max-width: 160px;
  }
  ${withQuery.xs.down()} {
    max-width: 150px;
  }
  ${withQuery.xxs.down()} {
    max-width: 140px;
  }
`;

const ShowMore = styled.div`
  cursor: pointer;
  font-size: 16px;
  color: ${getColor('primary')};
  font-weight: 600;
`;

export {
  SubtitleHelper,
  SectionContainer,
  HelperBox,
  FilesContainer,
  DropzoneContainer,
  ImageBoxContainer,
  MainMarker,
  ImageBorderWrapper,
  Image,
  Editable,
  Controls,
  Rotator,
  Deletor,
  LoadingView,
  SnackContainer,
  CollapseCheck,
  CollapseContainer,
  CollapseWrapper,
  MainSelector,
  ImgOverlay,
  ErrorMessage,
  CardShowMore,
  ShowMore
};
